import React from "react";

import "./ListLoading.css";

export const ListLoading = () => {
  return (
    <div className="ListLoading">
      <ListLoadingItem />
      <ListLoadingItem />
      <ListLoadingItem />
      <ListLoadingItem />
    </div>
  );
};

export const ListLoadingItem = () => (
  <div className="ListLoadingItem">
    <div className="ListLoadingItem__content">
      <div className="ListLoadingItem__shimmer">
        <div className="ListLoadingItem__shimmer-bar"></div>
      </div>
      <div className="ListLoadingItem__shimmer">
        <div className="ListLoadingItem__shimmer-bar"></div>
      </div>
      <div className="ListLoadingItem__shimmer">
        <div className="ListLoadingItem__shimmer-bar"></div>
      </div>
    </div>
  </div>
);

export const ListLoadingItemSingleBar = () => (
  <div className="ListLoadingItem">
    <div className="ListLoadingItem__content">
      <div className="ListLoadingItem__shimmer-bar"></div>
    </div>
  </div>
);
